<template>
  <div class="lego-tree" :class="{ 'view-mode': viewMode }">
    <template v-if="!hideAllActionGroup">
      <slot
        name="actionGroup"
        :expandAll="expandAll"
        :collapseAll="collapseAll"
        :selectedNode="selectedNode"
      >
        <lego-action-bar class="lego-tree__btn-group">
          <template v-slot:left>
            <slot
              name="actionGroupLeft"
              :expandAll="expandAll"
              :collapseAll="collapseAll"
              :emitClickAddButton="emitClickAddButton"
              :selectedNode="selectedNode"
            >
              <lego-button small @click.stop="expandAll">{{ t('button.expandAll') }}</lego-button>
              <lego-button small @click.stop="collapseAll">{{
                t('button.collapseAll')
              }}</lego-button>
            </slot>
          </template>
          <slot
            name="actionGroupRight"
            :expandAll="expandAll"
            :collapseAll="collapseAll"
            :emitClickAddButton="emitClickAddButton"
            :selectedNode="selectedNode"
          >
            <lego-button :hidden="hideAdd" small @click.stop="emitClickAddButton">
              Add
            </lego-button>
          </slot>
        </lego-action-bar>
      </slot>
      <hr class="lego-tree__divider" />
    </template>
    <c-scroll :style="contentStyle">
      <div v-if="!modelValue || modelValue.length === 0" class="lego-tree__empty">
        {{ emptyMessage }}
      </div>
      <div class="lego-tree__contents">
        <template v-for="(node, idx) in modelValue" :key="idx">
          <lego-tree-policy-node :node="node" :draggable="draggable" :position="[idx]">
            <template #treeNodeLabel="labelScope">
              <slot name="treeNodeLabel" v-bind="labelScope" />
            </template>
          </lego-tree-policy-node>
          <div class="add-btn" v-if="idx === modelValue.length - 1 && !viewMode" :key="idx">
            <lego-button small @click.stop="emitClickAddButton">
              <lego-icon iconType="df" icon="add_border" :iconSize="16" />
              {{ addPolicyRequirementText || t('button.addPolicyRequirement') }}
            </lego-button>
          </div>
        </template>
      </div>
    </c-scroll>
  </div>
</template>
<script>
import legoTreePolicyNode from './legoTreePolicyNode';
import i18nMixin from '@/mixins/i18n.mixin.js';

export default {
  name: 'lego-tree-policy',
  mixins: [i18nMixin],
  components: { legoTreePolicyNode },
  props: {
    hideAdd: {
      type: Boolean,
      default: true
    },
    labelAction: {
      type: Boolean,
      default: true
    },
    onlyRemove: {
      type: Boolean,
      default: true
    },
    addPolicyRequirementText: {
      type: String,
      default: ''
    },
    addPolicyObjectText: {
      type: String,
      default: ''
    },
    viewMode: {
      type: Boolean,
      default: false
    },
    hideAllActionGroup: {
      type: Boolean,
      default: false
    },
    noSelectNode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    contentStyle() {
      if (this.hideAllActionGroup) {
        return { height: '100%' };
      } else {
        return { height: 'calc(100% - 43px)' };
      }
      },
    },
  provide() {
    return {
      t: this.t,
      checkbox: this.checkbox,
      labelInfo: this.nodeLabel,
      labelAction: this.labelAction,
      inlineEdit: this.inlineEdit,
      rules: this.rules,
      reRender: this.reRender,
      onClickNode: this.onClickNode,
      onClickExpand: this.onClickExpand,
      onClickCheckbox: this.onClickCheckbox,
      emitClickDeleteButton: this.emitClickDeleteButton,
      emitClickEditButton: this.emitClickEditButton,
      emitClickAddButton: this.emitClickAddButton,

      dragstart: this.dragstart,
      dragenter: this.dragenter,
      dragleave: this.dragleave,
      dragend: this.dragend,
      onlyRemove: this.onlyRemove,
      addPolicyObjectText: this.addPolicyObjectText,
      viewMode: this.viewMode,
      noSelectNode: this.noSelectNode
    };
  }
};
</script>
<style lang="scss" scoped>
.lego-tree {
  &.view-mode {
    :deep .lego-tree-node__vertical-line {
      border-left: 0;
    }
  }
}

:deep .add-btn {
  height: 36px;
  display: flex;
  align-items: center;
  .lego-icon {
    font-size: 11px;
    margin-right: 8px;
  }
}
</style>
